export const detectWfhIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE work from home
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(work from home)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("work from home")
    ) {
        return {
            intent: "delete_work_from_home",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE work from home
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(work from home)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("work from home")
    ) {
        return {
            intent: "create_work_from_home",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
